module.exports = __webpack_public_path__ + "static/img/lg-chem-pr-portal-thumb.673b876.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/lg-chem-pr-portal-thumb.jpg
// module id = NegP
// module chunks = 0